import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVisualstudioComponent } from './simple-icons-visualstudio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVisualstudioComponent ],
    exports:      [ SimpleIconsVisualstudioComponent ],
    bootstrap:    []
})
export class SimpleIconsVisualstudioModule {}
